import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AuthTokens } from '~/libs/auth/types';
import { RootState } from '~/redux';

interface AuthErrorModel {
  message: string;
  status: number;
}

interface AuthState extends AuthTokens {
  error: AuthErrorModel | null;
}

const initialState: AuthState = {
  accessToken: '',
  idToken: '',
  error: null,
};

const authTokensSlice = createSlice({
  name: 'tokens',
  initialState,
  reducers: {
    setAuthTokens: (state, action: PayloadAction<AuthTokens>) => {
      state.accessToken = action.payload.accessToken;
      state.idToken = action.payload.idToken;
    },
    clearAuthTokens: (state) => {
      state.accessToken = '';
      state.idToken = '';
    },
    setAuthError: (state, action: PayloadAction<AuthErrorModel>) => {
      state.error = action.payload;
    },
    clearAuthError: (state) => {
      state.error = null;
    },
  },
});

export const { setAuthTokens, clearAuthTokens, setAuthError, clearAuthError } = authTokensSlice.actions;
export const selectAccessToken = (state: RootState) => state.authTokens.accessToken;
export const selectAuthError = (state: RootState) => state.authTokens.error;

export default authTokensSlice.reducer;
